import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.routesSettings.title',
    defaultMessage: 'Routing order',
    description: 'title of the routing settings on the configuration page',
  },
  feedback: {
    routingSettingsUpdated: {
      defaultMessage: 'Routing order saved',
      id: 'pages.settings.general.routesSettings.feedback.routingSettingsUpdated',
      description: 'feedback on the successful update of routing order settings',
    },
    routingSettingsNotUpdated: {
      id: 'pages.settings.general.routesSettings.feedback.routingSettingsNotUpdated',
      defaultMessage: 'Routing order could not be saved',
      description: 'feedback on the failed update of routing order settings',
    },
  },
  display: {
    label: {
      id: 'properties.routes',
      defaultMessage: 'Routes',
      description: 'label of the route array field',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.routesSettings.editDrawer.title',
      defaultMessage: 'Edit routing order',
      description: 'title of the edit price group drawer',
    },
    routesArrayField: {
      label: {
        id: 'properties.routes',
        defaultMessage: 'Routes',
        description: 'label of the route array field',
      },
    },
    routeField: {
      label: {
        id: 'properties.route',
        defaultMessage: 'Route',
        description: 'label of the route field',
      },
    },
    ordinalField: {
      label: {
        id: 'properties.ordinal',
        defaultMessage: 'Ordinal',
        description: 'label of the ordinal field',
      },
    },
    restrictedToField: {
      label: {
        id: 'properties.restrictedTo',
        defaultMessage: 'Restricted to',
        description: 'label of the restricted to field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
